module.exports = __webpack_public_path__ + "img/checkmark_white.f4370668.svg";